// @flow

import type { AppType } from "shared/types/AppType"

export default ({
  asyncComponentResolve: () => import("apps/role/Role"),
  orderPrio: 90,
  iconType: "idcard",
  name: "roles"
}: AppType)
